export default __webpack_public_path__ + "static/media/icon-instagram-white.71344ee8.svg";